import React from "react";
import { useContent } from "@/context/ContentContext";

/** The Okaytwitchy bio — handwritten, personal, all white, thick and readable. */
export default function BioText() {
  const { content } = useContent();
  const bio = content?.bio || {};
  const paras = bio.paragraphs || [];

  return (
    <div data-testid="artist-bio" className="font-hand text-white text-left">
      {paras.map((p, i) => (
        <p key={i} className="text-lg sm:text-xl leading-relaxed mb-5">
          {p}
        </p>
      ))}
      {bio.punchline && (
        <p className="text-2xl sm:text-3xl leading-snug mb-5 -rotate-1">
          {bio.punchline}
        </p>
      )}
      {bio.dedication && (
        <p className="text-lg sm:text-xl leading-relaxed mb-5">{bio.dedication}</p>
      )}
      {bio.mantra && (
        <p className="text-2xl sm:text-3xl leading-snug mb-7">
          {bio.mantra}
        </p>
      )}
      {bio.signoff && (
        <div className="inline-block border-l-4 border-[#F26522] pl-5">
          <p className="text-2xl sm:text-3xl leading-snug">{bio.signoff}</p>
          <p className="text-3xl sm:text-4xl mt-2">{bio.signature}</p>
        </div>
      )}
    </div>
  );
}
